<template>
  <div class="container">
    <h3 class="title">Mamy już wszystkie dane,<br/> niezbędne do otwarcia nowej sprawy.<br/> Prosimy o potwierdzenie zlecenia.</h3>
    <div class="btn-group">
      <button type="button" class="btn gray" :style="{ background: $color }" @click="setHomePage">NIE</button>
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler">TAK</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
export default {
  name: "StepLast",
  methods: {
    ...mapMutations(['setHomePage']),
    ...mapActions(['createClaim']),
    btnHandler () {
      if (this.steps[0].value === 'home') {
        this.createClaim('createnewhomeclaim')
      } else {
        this.createClaim('createnewmedclaim')
      }
    }
  },
  computed: {
    ...mapState(['steps'])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepLast.vue